import { render, staticRenderFns } from "./user-cdr-viewer.vue?vue&type=template&id=18ed547c&"
import script from "./user-cdr-viewer.vue?vue&type=script&lang=js&"
export * from "./user-cdr-viewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports